module.exports = __webpack_public_path__ + "static/media/3.0e19a085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/ourGame/3.jpg
// module id = 156
// module chunks = 0